<template>
  <div class="header-block">
    <h2>Need the Best-in-Class Traffic Control? We Can Help!</h2>
  </div>
  <div class="input-box">
    <div class="btn-options home-btns">
      <router-link to="/date" class="lighter btn">Place an Order</router-link>
      <a href="https://flaggerforce.com/contact-us/request-a-quote/" class="btn">Request An Estimate</a>
      <router-link to="/notsure" class="darker btn">Have Questions? - Let's Talk!</router-link>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Home',
  data() {
    return {
      sameAsPersonPlacingOrderBool: false,
      sameAsLocationOfWorkBool: false,
    }
  },
  watch: {
    'fields.indicateIfYourWorkIncludes': function(newValue, oldValue) {
      if( !oldValue.includes('None Of The Above') && newValue.includes('None Of The Above') ){
        this.fields.indicateIfYourWorkIncludes = ['None Of The Above']
      }else if(newValue.length > 1 && newValue.includes('None Of The Above')){
        this.fields.indicateIfYourWorkIncludes = newValue.filter(val => val !== 'None Of The Above')
      }
    }
  },
  mounted() {
    this.$store.commit('resetStuff')
  }
}
</script>

<style>

.home-btns .btn {
  display: block;
  margin: 15px 0;
  font-size: 1.2em;
  text-transform: uppercase;
  border-radius: 8px;
  max-width: 500px;
}

.btn.lighter { background: #f98f00; }

.btn.darker { background: #a02000; }

</style>